package com.taocent.simple.compose.component.blockrichtext.internal.serialization

import androidx.compose.ui.text.AnnotatedString
import com.taocent.simple.compose.component.blockrichtext.DocumentBlock
import com.taocent.simple.compose.component.blockrichtext.ExperimentalBlockRichTextApi
import com.taocent.simple.compose.component.blockrichtext.TextBlock
import com.taocent.simple.compose.component.blockrichtext.internal.registry.BlockKind
import com.taocent.simple.compose.component.blockrichtext.internal.registry.BlockSerializer
import com.taocent.simple.compose.component.richtext.core.internal.serialization.RichTextSerializer
import kotlin.reflect.KClass

@OptIn(ExperimentalBlockRichTextApi::class)
class TextBlockSerializer : BlockSerializer<TextBlock> {

    override val kind: BlockKind get() = BlockKind.TEXT

    override val blockClass: KClass<TextBlock>
        get() = TextBlock::class

    override fun typeName(): String = "text"

    override fun toJson(block: TextBlock): String {
        return "{\"type\":\"text\",\"content\":${RichTextSerializer.toJson(block.content)}}"
    }

    override fun toJson(block: TextBlock, contentResolver: ((DocumentBlock) -> AnnotatedString?)?): String {
        val resolved = contentResolver?.invoke(block)
        val content = resolved ?: block.content
        return "{\"type\":\"text\",\"content\":${RichTextSerializer.toJson(content)}}"
    }

    override fun fromJson(root: Map<String, Any?>): TextBlock? {
        val contentNode = root["content"] as? Map<*, *> ?: return null
        val annotated = RichTextSerializer.fromJsonMap(contentNode)
        return TextBlock(content = annotated)
    }
}
